// Shared validation for Client / Program / Project name fields.
// Whitelist: only letters, digits, dash, ampersand, and space are
// allowed. Names also cannot start with '&'.

export const DISALLOWED_NAME_CHARS_REGEX = /[^a-zA-Z0-9\-& ]/g;

export const getDisallowedNameCharacters = (name: string): string[] => {
  if (!name) return [];
  const matches = name.match(DISALLOWED_NAME_CHARS_REGEX);
  return matches ? Array.from(new Set(matches)) : [];
};

export const hasLeadingAmpersand = (name: string): boolean => {
  return !!name && name.trimStart().startsWith("&");
};

export const hasDisallowedNameCharacters = (name: string): boolean => {
  return getDisallowedNameCharacters(name).length > 0 || hasLeadingAmpersand(name);
};

export const buildDisallowedNameCharsMessage = (name: string): string => {
  const chars = getDisallowedNameCharacters(name);
  const messages: string[] = [];
  if (hasLeadingAmpersand(name)) {
    messages.push("Name cannot start with '&'");
  }
  if (chars.length > 0) {
    messages.push(`Name contains invalid character(s): ${chars.join(" ")}`);
  }
  return messages.join(". ");
};